(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elya-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.ecReady) return;
    root.dataset.ecReady = '1';
    var intro = root.querySelector('.ec-intro'), more = root.querySelector('.ec-more');
    if (intro && more && matchMedia('(max-width: 700px)').matches) {
      intro.classList.add('clamp');
      if (intro.scrollHeight > intro.clientHeight + 2) {
        more.hidden = false;
        more.addEventListener('click', function () { intro.classList.remove('clamp'); more.hidden = true; });
      } else intro.classList.remove('clamp');
    }
    var btns = root.querySelectorAll('[data-panel]');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var open = b.getAttribute('aria-expanded') !== 'true';
        btns.forEach(function (o) {
          o.setAttribute('aria-expanded', 'false');
          root.querySelector('#' + o.getAttribute('aria-controls')).hidden = true;
        });
        if (open) {
          b.setAttribute('aria-expanded', 'true');
          root.querySelector('#' + b.getAttribute('aria-controls')).hidden = false;
        }
      });
    });
    var form = root.querySelector('.ec-filters');
    if (form) form.addEventListener('submit', function () {
      form.querySelectorAll('input').forEach(function (i) { if (!i.value) i.disabled = true; });
    });
  }
  function initAll() { document.querySelectorAll('.ec').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elya-edito"]) return;
  try {
    (function(){
  var root=document.querySelector('.ed');if(!root)return;
  var els=root.querySelectorAll('[data-r],.ed-col,.ed-sw,.ed-q,.ed-tl,[data-count]');
  if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('in')});root.querySelectorAll('.ed-lv').forEach(function(e){e.classList.add('in')});return;}
  var io=new IntersectionObserver(function(en){en.forEach(function(e){if(!e.isIntersecting)return;var t=e.target;t.classList.add('in');io.unobserve(t);
    if(t.hasAttribute('data-count')){var end=+t.getAttribute('data-count'),st=null,b=t.querySelector('span');
      if(matchMedia('(prefers-reduced-motion:reduce)').matches){b.textContent=end;return;}
      requestAnimationFrame(function f(ts){st=st||ts;var p=Math.min((ts-st)/1400,1);b.textContent=Math.round(end*(1-Math.pow(1-p,3)));if(p<1)requestAnimationFrame(f)});}
  })},{threshold:.18,rootMargin:'0px 0px -6% 0px'});
  els.forEach(function(e){io.observe(e)});
  var asm=root.querySelector('.ed-asm');
  if(asm){var rm=matchMedia('(prefers-reduced-motion:reduce)').matches,tk=false;
    function ua(){var r=asm.getBoundingClientRect(),h=innerHeight,p=1-((r.top+r.height/2)-h*.5)/(h*.5);p=Math.max(0,Math.min(1,p));if(rm)p=1;
      asm.style.setProperty('--p',p.toFixed(3));if(p>.97)asm.classList.add('on');else if(p<.8)asm.classList.remove('on');tk=false}
    function qa(){if(!tk){tk=true;requestAnimationFrame(ua)}}document.addEventListener('scroll',qa,{passive:true,capture:true});var pw=document.querySelector('.page-wrapper');if(pw)pw.addEventListener('scroll',qa,{passive:true});if('IntersectionObserver' in window){var th=[];for(var q=0;q<=40;q++)th.push(q/40);new IntersectionObserver(function(){ua()},{threshold:th}).observe(asm)}addEventListener('resize',ua);ua();}
  var lio=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');lio.unobserve(e.target)}})},{rootMargin:'0px 0px 20% 0px',threshold:0});
  root.querySelectorAll('.ed-lv').forEach(function(e){lio.observe(e)});
  var pre=new IntersectionObserver(function(en){if(en[0].isIntersecting){root.querySelectorAll('img[loading=lazy]').forEach(function(i){i.loading='eager'});pre.disconnect()}},{rootMargin:'1600px 0px 1600px 0px'});
  pre.observe(root);
  var tabs=root.querySelector('.gd-tabs');
  if(tabs){var pill=tabs.querySelector('i'),bts=tabs.querySelectorAll('button');
    function sel(k){bts.forEach(function(b,j){b.setAttribute('aria-selected',j===k?'true':'false')});root.querySelectorAll('[data-pan]').forEach(function(pn){pn.classList.toggle('on',+pn.dataset.pan===k)});var b=bts[k];pill.style.width=b.offsetWidth+'px';pill.style.transform='translateX('+(b.offsetLeft-5)+'px)'}
    bts.forEach(function(b,j){b.addEventListener('click',function(){sel(j)})});sel(0);addEventListener('resize',function(){var k=[].findIndex.call(bts,function(b){return b.getAttribute('aria-selected')==='true'});sel(k<0?0:k)});}
  root.addEventListener('submit',function(ev){var f=ev.target.closest('[data-buy]');if(!f)return;var b=f.querySelector('.gd-add'),sp=b&&b.querySelector('span');if(!b)return;
    if(!f.getAttribute('action')){ev.preventDefault();}
    b.classList.add('ld');setTimeout(function(){b.classList.remove('ld');b.classList.add('ok');sp.textContent='Ajoutée ✓';
      if(!f.querySelector('.gd-go')){var g=document.createElement('a');g.className='gd-go';g.href='/cart';g.textContent='Voir mon panier →';f.appendChild(g)}
      setTimeout(function(){b.classList.remove('ok');sp.textContent='Ajouter au panier'},4000)},900)},true);
  var st=root.querySelector('[data-stick]');
  if(st){var grid=document.querySelector('.ec-grid')||document.querySelector('main');st.addEventListener('click',function(){grid.scrollIntoView({behavior:'smooth',block:'start'})});
    new IntersectionObserver(function(en){en.forEach(function(x){st.classList.toggle('on',x.isIntersecting)})},{rootMargin:'0px 0px -30% 0px'}).observe(root);}
  var par=root.querySelectorAll('[data-speed]');
  if(par.length&&!matchMedia('(prefers-reduced-motion:reduce)').matches){var tick=false;
    function upd(){par.forEach(function(e){var r=e.getBoundingClientRect(),c=r.top+r.height/2-innerHeight/2;e.style.transform='translateY('+(c*-(+e.dataset.speed)).toFixed(1)+'px)'});tick=false}
    function qp(){if(!tick){tick=true;requestAnimationFrame(upd)}}document.addEventListener('scroll',qp,{passive:true,capture:true});var pw2=document.querySelector('.page-wrapper');if(pw2)pw2.addEventListener('scroll',qp,{passive:true});upd();}
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elya-privileges"]) return;
  try {
    
(function(){
  var root=document.querySelector('.pv');if(!root)return;
  var card=root.querySelector('[data-card]');
  if(root.querySelector('[data-ok]')){if(card)card.classList.add('flip');var j=document.getElementById('inscription');if(j)setTimeout(function(){j.scrollIntoView({behavior:'smooth',block:'center'})},300)}
  root.addEventListener('click',function(e){var b=e.target.closest('[data-copy]');if(!b)return;var c=b.getAttribute('data-copy');(navigator.clipboard?navigator.clipboard.writeText(c):Promise.reject()).then(function(){b.textContent='Copié ✓'},function(){b.textContent=c})});
  var els=root.querySelectorAll('[data-pr],[data-steps]');
  if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('in')})}else{
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('in');io.unobserve(x.target)}})},{threshold:.15,rootMargin:'0px 0px -5% 0px'});
    els.forEach(function(e){io.observe(e)});
    var st=root.querySelector('[data-stick]'),join=document.getElementById('inscription');
    if(st&&join){var vis=true;new IntersectionObserver(function(en){vis=en[0].isIntersecting;st.classList.toggle('on',!vis&&!root.querySelector('[data-ok]'))}).observe(join)}
  }
  if(card&&matchMedia('(hover:hover)').matches&&!matchMedia('(prefers-reduced-motion:reduce)').matches){
    card.addEventListener('mousemove',function(e){if(card.classList.contains('flip'))return;var r=card.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;card.firstElementChild.style.animation='none';card.firstElementChild.style.transform='rotateY('+(x*14)+'deg) rotateX('+(-y*12)+'deg)'});
    card.addEventListener('mouseleave',function(){if(card.classList.contains('flip'))return;card.firstElementChild.style.transform='';card.firstElementChild.style.animation=''});
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
